import {brandConfigObjectMap, Brands} from "@/brand/brandConfig";

export const brandConfigMap = new Map();

brandConfigMap.set('http://localhost:8080', getBrandConfig('wp-za-en'));
brandConfigMap.set('http://localhost:8081', getBrandConfig('wp-za-en'));
brandConfigMap.set('https://league-xi.com', getBrandConfig('wp-za-en'));
brandConfigMap.set('https://staging.league-eleven.co.za', getBrandConfig('wp-za-en'));
brandConfigMap.set('https://league-eleven.co.za', getBrandConfig('wp-za-en'));
brandConfigMap.set('https://wp.league-eleven.co.za', getBrandConfig('wp-za-en'));

// Default fallback configuration
brandConfigMap.set('default', getBrandConfig('wp-za-en'));

export function getBrandConfig(brand) {
    const brandConfigObject = brandConfigObjectMap.get(brand);
    return {
        brand,
        gameTitle: brandConfigObject.gameTitle,
        freePlayServiceId: brandConfigObject.freePlayServiceId,
        baseRoute: brandConfigObject.baseRoute,
        productId: brandConfigObject.productId,
        serviceName: brandConfigObject.serviceName
    }
}
